import { COUNTRY_OPTIONS } from './countryOptions'
import { US_STATES, CA_STATES } from './stateOptions'

globalThis.ClickFunnels = globalThis.ClickFunnels ?? {}
globalThis.ClickFunnels.ISO_MAPPING = {
  all_countries: COUNTRY_OPTIONS,
  all_united_states: US_STATES,
  all_canadian_provinces: CA_STATES,
}

// Input is a .elSelect
export const populateSelect = (selectElement: HTMLElement): void => {
  const type = $(selectElement).parents('.elSelectWrapper').attr('data-type')
  const items = globalThis.ClickFunnels.ISO_MAPPING[type]
  if (items) {
    selectElement.innerHTML = ''
    items.forEach((item) => (selectElement.innerHTML += `<option value="${item.code}" > ${item.name} </option>`))
  }
}
window.addEventListener('load', function () {
  $('.elSelect').each((index, element) => {
    populateSelect(element as HTMLElement)
  })
})
